import { MotifErrorMessage, MotifLabel } from "@ey-xd/motif-react";
import {
  POSTAL_CODE_FIELD,
  PREFIX_NAME,
  PROVINCE_STATE_NAME,
} from "../../Constants";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  getNewCrediotrDetails,
  getStateListByCountry,
} from "../CreditorHelper";
import ContactSelect from "./ContactFormFields/ContactSelect";
import ContactFormInput from "./ContactFormFields/ContactFormInput";
import { useEffect, useState } from "react";
import { useGetStateByCountryIdQuery } from "@/services/countryState/countryStateReducer";
import { countryRecordType } from "@/pages/CaseDetail/Creditor/CreditorSetup/type";
import StateDropdown from "./ContactFormFields/StateDropdown";
import {
  INDIVIDUAL,
  ORGANIZATION,
  CREDITOR_TYPE,
  BUSINESS_NAME,
  DESCRIPTION,
  RELATIONSHIP_TO_DEBTOR,
  FIRST_NAME as CREDITOR_FIRST_NAME,
  LAST_NAME as CREDITOR_LAST_NAME,
} from "@/pages/CaseDetail/Creditor/CreditorSetup/Constants";
import RadioButtonGroup from "./ContactFormFields/RadioButtonGroup";
import PageSubTitle from "@/components/Form/PageSubTitle/PageSubTitle";
import Button from "@/components/Form/Button/Button";

import { Dispatch, SetStateAction } from "react";
import {
  CreditorSearchData,
  setIsNewCreditorType,
  setNewCreditorDetail,
} from "../creditorSlice";
import { useDispatch, useSelector } from "react-redux";
// import useResetAllClaimItemsStore from "../../useResetAllClaimItemsStore";
import { ClaimNewCreditorFormType } from "../type";
import ControlTextAreaWithCharLimit from "@/components/Form/InputBox/ControlTextAreaWithCharLimit";
import {
  CANCEL_BUTTON_VARIANT,
  NEXT_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { isCountryCanadaOrUS } from "@/utility/common";
import ControlInputBox from "../ControlInputBoxClaimSetupCreditor";

type NewContactFormProps = {
  setIsVisible: Dispatch<SetStateAction<boolean>>;
  goToNextTab: () => void;
  isDescriptionRequired: boolean;
};

interface RootState {
  claimSetupCreditorSearch: CreditorSearchData;
}

export default function NewContactForm({
  setIsVisible,
  goToNextTab,
  isDescriptionRequired,
}: NewContactFormProps) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [creditorType, setCreditorType] = useState(INDIVIDUAL);
  const defaultOptions = [{ label: "Please Select", value: "" }];
  const [countryArray, setCountryArry] = useState(defaultOptions);
  // const resetAllClaimItemsStore = useResetAllClaimItemsStore();

  const newCreditorDetailStore = useSelector(
    (state: RootState) => state.claimSetupCreditorSearch.newCreditorDetail
  );

  const {
    control,
    watch,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm<any>({ mode: "onChange" });

  const countrySelectedId = watch(`contact_countryId`)
    ? String(watch(`contact_countryId`))
    : watch(`contact_countryId`);

  const data = useSelector((state: any) => state.country.countryList);

  const { data: stateList, isFetching: statesLoading } =
    useGetStateByCountryIdQuery(countrySelectedId, {
      skip:
        countrySelectedId === "" ||
        countrySelectedId === undefined ||
        countrySelectedId === "0",
    });

  const selectedCountry = countryArray.find(
    (country) => country.value === countrySelectedId
  );
  const showstateDropdown =
    selectedCountry && isCountryCanadaOrUS(selectedCountry?.label);

  useEffect(() => {
    if (data !== undefined) {
      // eslint-disable-next-line array-callback-return
      const countryOptions = data.map((record: countryRecordType) => {
        return {
          label: record.countryName,
          value: record.countryId,
        };
      });
      setCountryArry(countryOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    if (creditorType === INDIVIDUAL) {
      setValue("businessName", "");
    } else {
      setValue("prefix", "");
      setValue("firstName", "");
      setValue("lastName", "");
    }
  }, [creditorType, setValue]);

  useEffect(() => {
    if (newCreditorDetailStore !== undefined) {
      setValue(`prefix`, newCreditorDetailStore.prefix);
      setValue(`firstName`, newCreditorDetailStore.firstName);
      setValue(`lastName`, newCreditorDetailStore.lastName);
      setValue(`businessName`, newCreditorDetailStore.businessName);
      setValue(`description`, newCreditorDetailStore.description);
      setValue(
        `relationShipToDebtor`,
        newCreditorDetailStore.relationshipToDebtor
      );
      setValue(`contact_firstName`, newCreditorDetailStore.contact.firstName);
      setValue(`contact_lastName`, newCreditorDetailStore.contact.lastName);
      setValue(`contact_prefix`, newCreditorDetailStore.contact.prefix);
      setValue(`contact_address1`, newCreditorDetailStore.contact.address1);
      setValue(`contact_address2`, newCreditorDetailStore.contact.address2);
      setValue(`contact_city`, newCreditorDetailStore.contact.city);
      setValue(
        `contact_provinceStateId`,
        newCreditorDetailStore.contact.provinceStateId
      );
      setValue(`provinceState`, newCreditorDetailStore.contact.provinceState);
      setValue(`contact_postalCode`, newCreditorDetailStore.contact.postalCode);
      setValue(`contact_countryId`, newCreditorDetailStore.contact.countryId);
      setValue(`contact_phone`, newCreditorDetailStore.contact.phone);
      setValue(`contact_fax`, newCreditorDetailStore.contact.fax);
      setValue(`contact_email`, newCreditorDetailStore.contact.email);
      setValue(
        `contact_relationshipToCreditor`,
        newCreditorDetailStore.contact.relationshipToCreditor
      );
      setValue(
        `contactBusinessName`,
        newCreditorDetailStore.contact.contactBusinessName
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newCreditorDetailStore]);

  useEffect(() => {
    if (countrySelectedId !== newCreditorDetailStore.contact.countryId) {
      setValue("contact_provinceStateId", "");
      setValue("provinceState", "");
    } else {
      setValue(
        "contact_provinceStateId",
        newCreditorDetailStore.contact.provinceStateId
      );
      setValue("provinceState", newCreditorDetailStore.contact.provinceState);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countrySelectedId]);

  // useEffect(() => {
  //   if (stateList !== undefined && stateList.length > 0) {
  //     const stateListBycounrty = getStateListByCountry(stateList);
  //     setValue("provinceStateOptions",
  // );
  //   } else {
  //     setValue("provinceStateOptions", defaultOptions);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isLoadingStateList, stateList]);

  // if (isLoadingStateList) {
  //   return <MotifProgressLoader show variant="default" />;
  // }
  const PREFIX_OPTIONS_LIST = [
    {
      label: t("global.globalActions.optionDefault"),
      value: "",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.mr"),
      value: "Mr.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.ms"),
      value: "Ms.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.mrs"),
      value: "Mrs.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.miss"),
      value: "Miss.",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.estateof"),
      value: "Estate of",
    },
    {
      label: t("global.globalActions.prefixOptionsListLabels.other"),
      value: "other",
    },
  ];

  const selectedCountryID =
    countryArray &&
    countryArray.length > 0 &&
    countryArray.find((country) => country.value === countrySelectedId);
  const IsCanadaOrUs =
    (selectedCountryID && isCountryCanadaOrUS(selectedCountryID?.label)) ||
    false;
  const selectedStateId = IsCanadaOrUs
    ? watch("contact_provinceStateId")
    : watch("provinceState");
  const stateListBycounrty = IsCanadaOrUs
    ? getStateListByCountry(stateList) || []
    : [];
  const stateId = IsCanadaOrUs
    ? stateListBycounrty && stateListBycounrty?.length > 0
      ? selectedStateId
      : ""
    : "";
  const onSubmit = (data: ClaimNewCreditorFormType) => {
    const newCreditorDetail = getNewCrediotrDetails(
      data,
      stateListBycounrty,
      countryArray,
      countrySelectedId,
      creditorType
    );
    dispatch(setIsNewCreditorType(true));
    dispatch(setNewCreditorDetail(newCreditorDetail));
    goToNextTab();
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="new-creditor-container">
          <div>
            <p className="form-description">
              {t("pages.claims.claimCreate.creditorTab.newCreditorDescription")}
            </p>
          </div>
          <div>
            <RadioButtonGroup
              name={CREDITOR_TYPE}
              required={true}
              defaultValue={
                newCreditorDetailStore.isOrg === true
                  ? ORGANIZATION
                  : INDIVIDUAL
              }
              options={[INDIVIDUAL, ORGANIZATION]}
              creditorType={creditorType}
              setCreditorType={setCreditorType}
            />
          </div>
          <div className="motif-row  flex-direction-column">
            <div style={{ width: "50%" }}>
              <div
                className={`motif-col-lg ${
                  creditorType === ORGANIZATION ? "" : "hide"
                }`}
              >
                <ContactFormInput
                  name={BUSINESS_NAME}
                  control={control}
                  label={
                    "pages.claims.claimCreate.creditorTab.formLabelsDetails.businessName"
                  }
                  required={creditorType === ORGANIZATION ? true : false}
                />
                {errors[BUSINESS_NAME] &&
                  errors[BUSINESS_NAME].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.claims.claimCreate.creditorTab.validationMessages.businessNameMessage"
                      )}
                    </MotifErrorMessage>
                  )}
              </div>
              <div
                className={`motif-col-lg  ${
                  creditorType === ORGANIZATION ? "hide" : ""
                }`}
              >
                {/*@ts-ignore*/}
                <ContactSelect
                  label={
                    "pages.claims.claimCreate.creditorTab.formLabelsDetails.prefix"
                  }
                  name={PREFIX_NAME}
                  options={PREFIX_OPTIONS_LIST}
                  control={control}
                />
                {errors[PREFIX_NAME] &&
                  errors[PREFIX_NAME].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.claims.claimCreate.creditorTab.validationMessages.prefixMessage"
                      )}
                    </MotifErrorMessage>
                  )}
              </div>
              <div
                className={`motif-col-lg mar-t-20 ${
                  creditorType === ORGANIZATION ? "hide" : ""
                }`}
              >
                <ContactFormInput
                  name={CREDITOR_FIRST_NAME}
                  control={control}
                  label={
                    "pages.claims.claimCreate.creditorTab.formLabelsDetails.firstName"
                  }
                  required={creditorType === ORGANIZATION ? false : true}
                />
                {errors[CREDITOR_FIRST_NAME] &&
                  errors[CREDITOR_FIRST_NAME].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.claims.claimCreate.creditorTab.validationMessages.firstNameMessage"
                      )}
                    </MotifErrorMessage>
                  )}
              </div>
              <div
                className={`motif-col-lg mar-t-20 ${
                  creditorType === ORGANIZATION ? "hide" : ""
                }`}
              >
                <ContactFormInput
                  name={CREDITOR_LAST_NAME}
                  control={control}
                  label={
                    "pages.claims.claimCreate.creditorTab.formLabelsDetails.lastName"
                  }
                  required={creditorType === ORGANIZATION ? false : true}
                />
                {errors[CREDITOR_LAST_NAME] &&
                  errors[CREDITOR_LAST_NAME].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.claims.claimCreate.creditorTab.validationMessages.lastNameMessage"
                      )}
                    </MotifErrorMessage>
                  )}
              </div>
            </div>
            <div style={{ width: "50%" }}>
              <div className={`motif-col-lg`}>
                {/*@ts-ignore*/}
                <ContactFormInput
                  name={RELATIONSHIP_TO_DEBTOR}
                  control={control}
                  label={
                    "pages.claims.claimCreate.creditorTab.formLabelsDetails.relationshipToDebtor"
                  }
                  required={false}
                />
              </div>
              <div className={`motif-col-lg mar-t-20`}>
                <ControlTextAreaWithCharLimit
                  name={DESCRIPTION}
                  control={control}
                  label={
                    "pages.claims.claimCreate.creditorTab.formLabelsDetails.description"
                  }
                  required={isDescriptionRequired}
                  isTextArea={true}
                  showLabel={true}
                />
                {errors[DESCRIPTION] &&
                  errors[DESCRIPTION].type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.claims.claimCreate.creditorTab.validationMessages.descriptionMessage"
                      )}
                    </MotifErrorMessage>
                  )}
              </div>
            </div>
          </div>

          <PageSubTitle
            title={
              "pages.claims.claimCreate.creditorTab.newCreditorContactDetailsTile"
            }
          />
          <div className="motif-body1-default-regular primary-contact-title">
            {t(
              "pages.claims.claimCreate.creditorTab.formLabelsDetails.primaryContactDetails"
            )}
          </div>
        </div>
        <div className="motif-row mar-t-30">
          <div className="motif-col-lg-6">
            {/*@ts-ignore*/}
            <ContactSelect
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.prefix"
              }
              name={`contact_prefix`}
              options={PREFIX_OPTIONS_LIST}
              control={control}
            />
            {errors[`contact_prefix`] &&
              errors[`contact_prefix`].type === "required" && (
                <MotifErrorMessage>
                  {t(
                    "pages.claims.claimCreate.creditorTab.validationMessages.prefixMessage"
                  )}
                </MotifErrorMessage>
              )}
          </div>
          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contact_firstName`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.firstName"
              }
              required={true}
            />
            {errors[`contact_firstName`] &&
              errors[`contact_firstName`].type === "required" && (
                <MotifErrorMessage>
                  {t(
                    "pages.claims.claimCreate.creditorTab.validationMessages.firstNameMessage"
                  )}
                </MotifErrorMessage>
              )}
          </div>
        </div>
        <div className="motif-row mar-t-30">
          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contact_lastName`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.lastName"
              }
              required={true}
            />
            {errors[`contact_lastName`] &&
              errors[`contact_lastName`].type === "required" && (
                <MotifErrorMessage>
                  {t(
                    "pages.claims.claimCreate.creditorTab.validationMessages.lastNameMessage"
                  )}
                </MotifErrorMessage>
              )}
          </div>
          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contactBusinessName`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.businessName"
              }
              required={false}
            />
          </div>
        </div>
        <div className="motif-row mar-t-30">
          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contact_email`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.email"
              }
              required={false}
            />
          </div>

          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contact_phone`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.phoneNumber"
              }
              isNumber={false}
              required={false}
            />
          </div>
        </div>
        <div className="motif-row mar-t-30">
          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contact_fax`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.fax"
              }
              isNumber={false}
              required={false}
            />
            {errors["contact_fax"] &&
              (errors["contact_fax"].type === "required" ||
                errors["contact_fax"].type === "pattern") && (
                <MotifErrorMessage>
                  {t(
                    "pages.claims.claimCreate.creditorTab.validationMessages.faxMessage"
                  )}
                </MotifErrorMessage>
              )}
          </div>
          <div className="motif-col-lg-6">
            {/*@ts-ignore*/}
            <ContactFormInput
              name={`contact_relationshipToCreditor`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.relationshipToCreditor"
              }
              required={false}
            />
          </div>
        </div>
        <div className="motif-row mar-t-30">
          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contact_address1`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.address1"
              }
              required={false}
            />
          </div>
          <div className="motif-col-lg-6">
            <ContactFormInput
              name={`contact_address2`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.address2"
              }
              required={false}
            />
          </div>
        </div>
        <div className="motif-row justify-content-end mar-t-30">
          <div className="motif-col-lg-3">
            {/*@ts-ignore*/}
            <ContactSelect
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.country"
              }
              name={`contact_countryId`}
              options={countryArray}
              control={control}
              selectedId={countrySelectedId}
              required={false}
              filter={true}
              placeHolder={t("global.globalPlaceholder.countryPlaceholder")}
            />
          </div>
          {showstateDropdown ? (
            <div className="motif-col-lg-3">
              {/*@ts-ignore*/}
              <StateDropdown
                countryID={countrySelectedId}
                control={control}
                stateId={stateId}
                stateListByCountry={stateListBycounrty}
                required={false}
                name={`contact_provinceStateId`}
                disabled={statesLoading}
              />
              {statesLoading && (
                <MotifLabel>
                  {t("global.globalNotifications.loadingMessage")}
                </MotifLabel>
              )}
            </div>
          ) : (
            <div className="motif-col-lg-3">
              <ControlInputBox
                name={PROVINCE_STATE_NAME}
                //@ts-ignore
                control={control}
                required={false}
                isTextArea={false}
                label={
                  "pages.creditors.creditorForm.formLabelDetails.provinceState"
                }
                showLabel={true}
              />
            </div>
          )}
          <div className="motif-col-lg-3">
            <ContactFormInput
              name={`contact_city`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.city"
              }
              required={false}
            />
          </div>
          <div className="motif-col-lg-3">
            <ContactFormInput
              name={`contact_${POSTAL_CODE_FIELD}`}
              control={control}
              label={
                "pages.claims.claimCreate.creditorTab.formLabelsDetails.postalCode"
              }
            />
          </div>
        </div>

        <div className="display-flex justify-content-end mar-t-70 button-container sticky-footer">
          <Button
            type="button"
            label={t("global.globalActions.cancel")}
            variant={CANCEL_BUTTON_VARIANT}
            className="cancelBtn"
            onClickHandler={() => setIsVisible(true)}
          />
          <Button
            label={t("global.globalActions.next")}
            variant={NEXT_BUTTON_VARIANT}
          />
        </div>
      </form>
    </>
  );
}
